export default {
	edit: 'Editar',
	delete: 'Eliminar',
	enable: 'Activar para este escenario',
	disable: 'Desactivar para este escenario',
	next_step: 'Siguiente paso',
	skip: 'Omitir',
	finish_review: 'Finalizar revisión',
	skip_review: 'Omitir la verificación',
	view: 'Ver detalles',
	close: 'Cerrar',
	cancel: 'Cancelar',
	send: 'Enviar',
	clone: 'Clonar',
	open: 'Abrir',
	sign_out: 'Cerrar sesión',
	search: 'Buscar',
	save: 'Guardar',
	sort_by_name: 'Ordenar por nombre (A→Z)',
	sort_by_importance: 'Ordenar por importancia (alta→baja)',
	filter_positive: 'Filtrar partes interesadas positivas',
	filter_negative: 'Filtrar partes interesadas negativas',
	export: {
		excel: 'Exportar como archivo Excel',
		image: 'Exportar visualización como imagen'
	},
	click_to_select: 'Haz clic para seleccionar',
	click_to_drag: 'Arrastrar y soltar para mover',
	confirm_drop: {
		message_baseline:
			'Estás actualizando la baseline, ¿confirmas los cambios?',
		message_scenario:
			'Estás actualizando el escenario {{scenarioName}}, ¿confirmas los cambios?',
		likelihood: 'Probabilidad',
		impact: 'Impacto',
		before: 'Antes',
		after: 'Después'
	}
};
